import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { RelatedList, RelatedListItem, RelatedSettings } from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'
import { WorkspaceDefaults } from '../useGetWorkspaceDefaults'

export const AppearanceWorkspaceDefaults = ({
  workspaceDefaults,
}: {
  workspaceDefaults: WorkspaceDefaults
}): JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.multiAnchor.workspaceDefaults',
  })
  const { workspaceId } = useWorkspaceParam()

  const { customStyling, fullWidthMode, showCloseButton } = workspaceDefaults

  return (
    <RelatedSettings title={t('title')}>
      <RelatedList>
        <RelatedListItem
          content={t('showCloseButton')}
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            section: 'multi-anchor',
            tab: 'rich-placements',
            workspaceId,
          })}
          value={tc(`booleanState.${showCloseButton}`)}
        />

        <RelatedListItem
          content={t('fullWidthMode')}
          value={tc(`booleanState.${fullWidthMode}`)}
        />

        <RelatedListItem
          content={t('customStyling')}
          value={tc(`definedState.${customStyling.length > 0}`)}
        />
      </RelatedList>
    </RelatedSettings>
  )
}
